import { useRevenueAccess } from './useRevenueAccess';

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const { isAdmin, loading } = useRevenueAccess();
  return { isAdmin, loading };
}
